import { Button } from '../ui/button';
import { cn } from '../../lib/utils';

export function DeleteConfirmModal({
  isOpen,
  isDark,
  onClose,
  onConfirm
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className={cn(
        'w-full max-w-sm rounded-xl border p-6',
        isDark ? 'bg-zinc-900 border-white/10' : 'bg-white border-gray-200'
      )}>
        <h3 className={cn(
          'text-lg font-semibold mb-2',
          isDark ? 'text-white' : 'text-gray-900'
        )}>
          Supprimer ce message ?
        </h3>
        <p className={cn(
          'text-sm mb-6',
          isDark ? 'text-zinc-400' : 'text-gray-600'
        )}>
          Ce message sera supprimé pour vous. L'autre utilisateur verra qu'un message a été supprimé.
        </p>
        <div className="flex gap-3 justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            className={isDark ? 'border-white/20 text-white hover:bg-white/10' : ''}
          >
            Annuler
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-red-500 hover:bg-red-600 text-white"
          >
            Supprimer
          </Button>
        </div>
      </div>
    </div>
  );
}
